export const GET_ALL_APP_SUBSCRIPTIONS_QUERY = /* GraphQL */ `
    query GetAllAppSubscriptions($first: Int!) {
        currentAppInstallation {
            id
            app {
                handle
                title
            }

            activeSubscriptions {
                id
                name
                status
                createdAt
                currentPeriodEnd
                trialDays
                test
                lineItems {
                    id
                    plan {
                        pricingDetails {
                            ... on AppRecurringPricing {
                                price {
                                    amount
                                    currencyCode
                                }
                                interval
                                planHandle
                                discount {
                                    durationLimitInIntervals
                                    priceAfterDiscount {
                                        amount
                                        currencyCode
                                    }
                                    remainingDurationInIntervals
                                    value {
                                        ... on AppSubscriptionDiscountAmount {
                                            amount {
                                                amount
                                                currencyCode
                                            }
                                        }
                                        ... on AppSubscriptionDiscountPercentage {
                                            percentage
                                        }
                                    }
                                }
                            }
                            ... on AppUsagePricing {
                                balanceUsed {
                                    amount
                                    currencyCode
                                }
                                cappedAmount {
                                    amount
                                    currencyCode
                                }
                                interval
                                terms
                            }
                        }
                    }
                }
            }

            allSubscriptions(first: $first, sortKey: CREATED_AT, reverse: true) {
                edges {
                    node {
                        id
                        name
                        status
                        createdAt
                        currentPeriodEnd
                        trialDays
                        test
                        lineItems {
                            id
                            plan {
                                pricingDetails {
                                    ... on AppRecurringPricing {
                                        price {
                                            amount
                                            currencyCode
                                        }
                                        interval
                                        planHandle
                                        discount {
                                            durationLimitInIntervals
                                            priceAfterDiscount {
                                                amount
                                                currencyCode
                                            }
                                            remainingDurationInIntervals
                                            value {
                                                ... on AppSubscriptionDiscountAmount {
                                                    amount {
                                                        amount
                                                        currencyCode
                                                    }
                                                }
                                                ... on AppSubscriptionDiscountPercentage {
                                                    percentage
                                                }
                                            }
                                        }
                                    }
                                    ... on AppUsagePricing {
                                        balanceUsed {
                                            amount
                                            currencyCode
                                        }
                                        cappedAmount {
                                            amount
                                            currencyCode
                                        }
                                        interval
                                        terms
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export interface GetAllAppSubscriptionsVariables {
    [key: string]: unknown;
    first: number;
}

export type AppBillingInterval = 'ANNUAL' | 'EVERY_30_DAYS';

export interface AppInstallationMoney {
    amount: string;
    currencyCode: string;
}

export interface AppInstallationDiscount {
    durationLimitInIntervals: number;
    priceAfterDiscount: AppInstallationMoney;
    remainingDurationInIntervals: number;
    value: { amount: AppInstallationMoney } | { percentage: number };
}

export interface AppRecurringPricingDetails {
    price: AppInstallationMoney;
    interval: AppBillingInterval;
    discount: AppInstallationDiscount | null;
    planHandle: string;
}

export interface AppUsagePricingDetails {
    balanceUsed: AppInstallationMoney;
    cappedAmount: AppInstallationMoney;
    interval: AppBillingInterval;
    terms: string;
}

export interface AppInstallationLineItem {
    id: string;
    plan: {
        pricingDetails: AppRecurringPricingDetails | AppUsagePricingDetails;
    };
}

export { SubscriptionStatus } from 'models/SubscriptionStatus';
import { SubscriptionStatus } from 'models/SubscriptionStatus';

export interface AppInstallationSubscription {
    id: string;
    name: string;
    status: SubscriptionStatus;
    createdAt: string;
    currentPeriodEnd: string;
    trialDays: number;
    test: boolean;
    lineItems: AppInstallationLineItem[];
}

export interface GetAllAppSubscriptionsResponse {
    currentAppInstallation: {
        id: string;
        app: {
            handle: string;
            title: string;
        };
        activeSubscriptions: AppInstallationSubscription[];
        allSubscriptions: { nodes: AppInstallationSubscription[] };
    };
}
